module.exports = __webpack_public_path__ + "img/KarlusMorales_Imagotype_Dark_120.6a0a3378.svg";